var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-corners",attrs:{"id":"small-map"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }